module.exports = __webpack_public_path__ + "static/img/font.3645dd1d.png";